'use client';

import type { ListAssetsInput } from '@impact/assets';
import { useAssetsList } from '@/lib/queries/assets';

export function useAssetGallery(filters: ListAssetsInput = {}) {
  return useAssetsList({
    limit: 50,
    offset: 0,
    sortBy: 'createdAt',
    sortOrder: 'desc',
    ...filters,
  });
}
